import { CXConfiguration, ProjectConfig, VueIntegrationLibrary } from '@adtelligence/vue-integration-library'
import { getComponentFromLocation } from '@adtelligence/vue-integration-library'
import App from './App.vue'

const isConsentRequired = false
const isConsentGivenOrNotRequired = function () {
  return !isConsentRequired
}
const config = new CXConfiguration({
  isConsentRequired,
  isConsentGivenOrNotRequired,
  service: new URL('https://demo-service.adtelligence.de/convertplus-web-rest/rest/content/objects'),
  epcAnalyticsLocation: new URL('https://demo-tracking.adtelligence.de'),
  companyId: 73,
  analyticsSiteId: 72,
  pageId: 156,
  hideOnStartTimeout: 150,
  enableSecureCookies: false,
  toolbarClientLocation: 'https://demo-service.adtelligence.de/cdk-toolbar-client/',
  toolbarLocation: 'https://demo-service.adtelligence.de/cdk-toolbar/',
  nonAnalyticsCookies: [
    { partialCookieName: 'adt_opt_out', topDomain: true },
    { partialCookieName: '_adt_delivery', topDomain: true },
    {
      partialCookieName: 'adt_firstvisit',
      topDomain: false
    },
    { partialCookieName: 'adt_recurring', topDomain: false }
  ],
  appParentElementSelector: 'header'
})
const overrideDeliveryParameters = window.location.hash.match(/edit-variation=([0-9]*),([0-9]*),([0-9]*)/)
let overrideURLSearchParams = null
if (overrideDeliveryParameters?.length === 4) {
  overrideURLSearchParams = new URLSearchParams(
      `contentGroup=${overrideDeliveryParameters[3]}&test=${overrideDeliveryParameters[1]}&source=${overrideDeliveryParameters[2]}&adtShowDeactivated=true`
  )
}
const projectConfig = new ProjectConfig(
    getComponentFromLocation([
      {
        projectId: 1021,
        pathnames: ['/ai-und-daten/'],
        strict: true,
        hideOnStart: true,
        projectParameters: overrideURLSearchParams ?? new URLSearchParams('adt=ai-und-daten'),
        getElementsToHide: componentKey => (componentKey ? document.getElementsByClassName('hideme') : [])
      }
    ])
)

const instance = new VueIntegrationLibrary(config, projectConfig, App)
instance.setAfterMatomoIsLoadedCallback(() => {})
